import VideoPlaySmall from '@repo/ui/src/components/Icons/VideoPlaySmall';
import { StateSetterFunction } from '@repo/ui/src/types/helpers';

// @TODO deprecate once new buttons are in

interface Props {
  text: string;
  setOpenModal: StateSetterFunction<boolean>;
}

const WatchNowButton = ({ setOpenModal, text }: Props) => {
  return (
    <button
      onClick={() => setOpenModal((curr) => !curr)}
      className="tra-text-web-utl-button-l text-white flex items-center p-2"
    >
      <VideoPlaySmall color="#D95E16" className="mr-4" />
      {text}
    </button>
  );
};

export default WatchNowButton;
